import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { StatusSubstatusInterface } from 'src/app/util/interfaces/substatus';

@Injectable({
	providedIn: 'root',
})
export class SubstatusService {
	private getStatusSubstatusURL = environment.baseApiUrl + 'register/substatus';
	private postStatusSubstatusURL = environment.baseApiUrl + 'register/substatus';
	private putStatusSubstatusURL = environment.baseApiUrl + 'register/substatus/{id}';
	private deleteStatusSubstatusURL = environment.baseApiUrl + 'register/substatus';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getStatusSubstatus(): Observable<StatusSubstatusInterface[]> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});

		return this.httpClient.get<any[]>(this.getStatusSubstatusURL, { headers: headers });
	}

	postStatusSubstatus(data: StatusSubstatusInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			status: data.statusId,
			substatus: data.substatus,
		};

		return this.httpClient.post(this.postStatusSubstatusURL, body, { headers: headers });
	}

	putStatusSubstatus(data: StatusSubstatusInterface): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const putStatusSubstatusURL = this.putStatusSubstatusURL.replace('{id}', data.id.toString());
		const body = {
			status: data.statusId,
			substatus: data.substatus,
		};

		return this.httpClient.put(putStatusSubstatusURL, body, { headers: headers });
	}

	deleteStatusSubstatus(data: number[]): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = JSON.stringify({ ids: data });

		return this.httpClient.delete(this.deleteStatusSubstatusURL, {
			headers: headers,
			body: body,
		});
	}
}
